<template>
  <hr />
  <h4>
    Questões:
    <span
      v-if="courseSelected.status == 2"
      role="button"
      class="badge bg-primary"
      title="Cadastrar Questão"
      @click="$emit('createQuestion')"
    >
      Cadastrar
    </span>
  </h4>
  <ul v-if="questions.length > 0" class="list list-unstyled">
    <li v-for="(question, index) in questions" :key="question.id">
      {{ index + 1 }} - {{ question.text }}
      <span
        role="button"
        class="badge bg-warning"
        title="Editar Questão"
        @click="$emit('editQuestion', question.id)"
      >
        Editar
      </span>
      <ul class="list">
        <li v-for="answer in question.answers" :key="answer.id">
          <span :class="{ 'text-success': answer.isCorrect == 1 }">
            {{ answer.text }}
          </span>
        </li>
      </ul>
    </li>
  </ul>
  <p v-else>Nenhuma questão cadastrada</p>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'QuestionsLesson',

  props: {
    questions: {
      type: Array,
      required: true,
    },
  },

  emits: ['createQuestion', 'editQuestion'],

  computed: {
    ...mapGetters(['courseSelected']),
  },
}
</script>
